var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "toolbar",
        { attrs: { title: "Company Accounts" } },
        [
          _c(
            "v-icon",
            {
              on: {
                click: function($event) {
                  return _vm.loadCompanies()
                }
              }
            },
            [_vm._v("refresh")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("v-layout", { attrs: { column: "" } }, [
        _c(
          "div",
          { staticClass: "pt-3" },
          [
            _c(
              "v-card",
              [
                _c(
                  "v-tabs",
                  {
                    attrs: { color: "white" },
                    model: {
                      value: _vm.tab,
                      callback: function($$v) {
                        _vm.tab = $$v
                      },
                      expression: "tab"
                    }
                  },
                  [
                    _c("v-tabs-slider", { attrs: { color: "primary" } }),
                    _vm._v(" "),
                    _c("v-tab", { key: "verified" }, [
                      _vm._v(
                        "\n            Verified (" +
                          _vm._s(_vm.verifiedCompanies.length) +
                          ")\n          "
                      )
                    ]),
                    _vm._v(" "),
                    _c("v-tab", { key: "unverified" }, [
                      _vm._v(
                        "\n            Unverified (" +
                          _vm._s(_vm.unverifiedCompanies.length) +
                          ")\n          "
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-tabs-items",
                  {
                    model: {
                      value: _vm.tab,
                      callback: function($$v) {
                        _vm.tab = $$v
                      },
                      expression: "tab"
                    }
                  },
                  [
                    _c(
                      "v-tab-item",
                      { key: "verified" },
                      [
                        _c("company-table", {
                          attrs: { companies: _vm.verifiedCompanies }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-tab-item",
                      { key: "unverified" },
                      [
                        _c("company-table", {
                          attrs: { companies: _vm.unverifiedCompanies }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f4db761a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f4db761a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Companies/CompanyList.vue
// module id = null
// module chunks = 